import { realtimeBridgeStore } from '@/services/realtime/bridge-store';
import { getTabId } from '@/services/realtime/tab-id';

export const ORIGIN_TAB_HEADER = 'X-Origin-Tab';

/**
 * Names this tab on a ui_api request. ui_api puts the id on the realtime event for the write, so
 * this tab can tell its own changes from everyone else's (CON-8726): whatever made the request
 * updates the tab from its own response, and the events are for every other tab.
 *
 * It is sent only while hydra has a realtime bridge, which is while this tab is on a page that
 * uses realtime. Nothing else reads the id.
 */
export function getOriginTabHeaders(): Record<string, string> {
  return realtimeBridgeStore.get() === null ? {} : { [ORIGIN_TAB_HEADER]: getTabId() };
}
